/**!
 *  Form for creating or editing a skill-building activity.
 */

import React, {useEffect, useState} from 'react'
import styles from './skillBuilding.module.scss'

import ContentField from 'Components/UI/Field/ContentField'
import ImageField from 'Components/UI/Field/ImageField'
import RepeaterField from 'Components/UI/Field/RepeaterField'
import Specializations from './specializations'
import TextField from 'Components/UI/Field/TextField'
import TextareaField from 'Components/UI/Field/TextareaField'

const Edit = ({className = '', community = 0, data: inputData, onChange, onReadyState}) =>
{
    const [data, setData] = useState(inputData || {})
    const [initial, setInitial] = useState(inputData || {})
    const required = ['name', 'description']

    useEffect(() =>
    {
        let ready = true
        required.forEach(key =>
        {
            if (
                data[key] === undefined || !data[key] ||
                (Array.isArray(data[key]) && data[key].length === 0)
            ) {
                ready = false
            }
        })
        onReadyState && onReadyState(ready)
    }, [data])

    useEffect(() =>
    {
        setInitial(inputData || {})
    }, [inputData])

    const hasChanged = (input) =>
    {
        const image = parseImage(input.image)
        const topic = Array.isArray(input.topic) ? input.topic[0] : input.topic || null
        return JSON.stringify({...input, image, topic}) !== JSON.stringify(initial)
    }

    const onEdit = (_, value, key) =>
    {
        setData(prev => ({...prev, [key]: value}))
        onChange && onChange({...data, [key]: value}, hasChanged({...data, [key]: value}))
    }

    const parseImage = (input) =>
    {
        if (!Array.isArray(input))
        {
            return input
        }
        return input.length > 0 ? input[0] : null
    }

    return (
        <div className={[styles.formWrapper, className].filter(c => !!c).join(' ')}>
            <form
                className={styles.form}
            >
                <div className={styles.formLeft}>
                    <TextField
                        id='name'
                        label='Name'
                        onChange={onEdit}
                        onInput={onEdit}
                        value={data.name}
                    />
                    <TextareaField
                        id='description'
                        label='Description'
                        onChange={onEdit}
                        onInput={onEdit}
                        value={data.description}
                    />
                    <ImageField
                        id='image'
                        label='Image'
                        onChange={onEdit}
                        value={data.image && (Array.isArray(data.image) ? data.image : [data.image])}  
                    />
                    <ContentField
                        id='topic'
                        label='Topic'
                        onChange={onEdit}
                        placeholder='Add a topic...'
                        types={['Topic']}
                        value={data.topic ? [[data.topic, 'topic']] : []}
                    />
                </div>
                <div className={styles.formRight}>
                    <Specializations
                        className={styles.specializations}
                        community={community}
                        label='Specializations'
                        selected={data.specializations}
                        onChange={(selected) => onEdit(null, selected, 'specializations')}
                    />
                    <RepeaterField
                        id='activities'
                        label='Skill Activities'
                        fields={{
                            title: {
                                label: 'Title',
                                type: 'text'
                            },
                            description: {
                                label: 'Description',
                                type: 'textarea'
                            },
                            type: {
                                label: 'Activity type',
                                type: 'select',
                                options: {
                                    skill: 'Skill activity',
                                    social: 'Social activity',
                                    experiential: 'Experiential activity' 
                                },
                                default: 'skill'
                            },
                            article: {
                                label: 'Article',
                                type: 'content',
                                placeholder: 'Search for articles...',
                                types: ['article'],
                                displayIf: ['useLink', '!==', true]
                            },
                            useLink: {
                                label: 'Use link instead',
                                type: 'checkbox'
                            },
                            link: {
                                label: 'Link',
                                type: 'url',
                                default: 'https://',
                                displayIf: ['useLink', '===', true]
                            }
                        }}
                        onChange={onEdit}
                        addLabel='Add activity'
                        itemName='Activity'
                        value={data.activities || []}
                    />
                </div>
            </form>
        </div>
    )
}

export default Edit